package data

import kotlin.js.json
import kotlin.js.Promise
import kotlinx.coroutines.await

// --- CONFIGURACIÓN DE FIREBASE MODULAR (V10) ---

@JsModule("firebase/app")
@JsNonModule
external object FirebaseApp {
    fun initializeApp(config: dynamic): dynamic
}

@JsModule("firebase/app-check")
@JsNonModule
external object AppCheck {
    fun initializeAppCheck(app: dynamic, options: dynamic): dynamic
    @JsName("ReCaptchaEnterpriseProvider")
    class ReCaptchaEnterpriseProvider(siteKey: String)
}

@JsModule("firebase/firestore")
@JsNonModule
external object Firestore {
    fun getFirestore(app: dynamic): dynamic
    fun doc(db: dynamic, path: String): dynamic
    fun collectionGroup(db: dynamic, collectionId: String): dynamic
    fun query(ref: dynamic, vararg constraints: dynamic): dynamic
    fun where(field: String, opPath: String, value: dynamic): dynamic
    fun limit(n: Int): dynamic
    fun getDoc(ref: dynamic): Promise<dynamic>
    fun getDocs(query: dynamic): Promise<dynamic>
}

object FirebaseConfig {
    private val config = json(
        "apiKey" to "AIzaSyDQodiuZEsY4eWFeoLp9AeAu2m-GUb7efg",
        "authDomain" to "drrecipeapp.com",
        "projectId" to "dr-recipe-31eb8",
        "storageBucket" to "dr-recipe-31eb8.firebasestorage.app",
        "messagingSenderId" to "998403555548",
        "appId" to "1:998403555548:web:f5b16f1ba2d6de1538b419",
        "measurementId" to "G-EZMC6WZCGQ"
    )

    private var app: dynamic = null
    private var db: dynamic = null

    fun init() {
        if (app == null) {
            app = FirebaseApp.initializeApp(config)
            
            // --- ACTIVACIÓN DE ESCUDO APP CHECK ---
            try {
                // Usamos la clave de reCAPTCHA Enterprise que generamos
                val provider = AppCheck.ReCaptchaEnterpriseProvider("6LfXf-osAAAAAEkdUXHEryshVKXqztU9VwkhS5mO")
                AppCheck.initializeAppCheck(app, json(
                    "provider" to provider,
                    "isTokenAutoRefreshEnabled" to true
                ))
                println("App Check: Escudo de seguridad activado con reCAPTCHA Enterprise")
            } catch (e: dynamic) {
                println("App Check Error: ${e.message}")
            }

            db = Firestore.getFirestore(app)
            println("Firebase: Base de Datos conectada y protegida.")
        }
    }

    private fun getDb(): dynamic = db

    suspend fun findConsultationById(consultationId: String): dynamic {
        val db = getDb()
        // Importa 'limit' si no lo tienes en tu objeto Firestore externo
        val q = Firestore.query(
            Firestore.collectionGroup(db, "consultations"),
            Firestore.where("id", "==", consultationId),
            Firestore.limit(1)
        )
        
        try {
            val querySnapshot = Firestore.getDocs(q).await()
            if (querySnapshot.empty == true) return null
            return querySnapshot.docs[0].data()
        } catch (e: dynamic) {
            println("Error en Firestore: ${e.message}")
            throw e
        }
    }

    suspend fun getDoctorData(doctorId: String): dynamic {
        val db = getDb()
        val docRef = Firestore.doc(db, "users/$doctorId")
        val snapshot = Firestore.getDoc(docRef).await()
        return if (snapshot.exists() == true) snapshot.data() else null
    }

    suspend fun getPatientData(patientId: String): dynamic {
        val db = getDb()
        val docRef = Firestore.doc(db, "patients/$patientId")
        val snapshot = Firestore.getDoc(docRef).await()
        return if (snapshot.exists() == true) snapshot.data() else null
    }
}
